import { TelevisionOffIcon } from './TelevisionOffIcon';

/**
 * author: Austin Andrews
 * id 9E9D949B-13EC-43FB-9068-2BED76224BD8
 * name television-off
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-off.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const TvOffIcon = TelevisionOffIcon;
export default TvOffIcon